import * as React from 'react';
import {observer} from 'mobx-react';
import {Tag, Flex, flexWrapProps, Scrollbar} from '@priority-software/priority-style-react';
import {isRTL} from '../../Localization';

export type Props = {
    tags: string[] | Array<{value: string; desc: string}>;
    active?: boolean;
    fullDisplay?: boolean;
    removeTag?: null | ((index: number) => void);
    maxHeight?: number;
};

export const TagsArea = observer(
    ({tags, active = true, fullDisplay = false, removeTag = null, maxHeight}: Props) => {
        return (
            tags && (
                <Scrollbar
                    autoHeightMax={fullDisplay ? undefined : maxHeight || 120}
                    autoHeight={true}
                    autoHide={false}
                    rtl={isRTL()}
                >
                    <Flex {...flexWrapProps}>
                        {tags.map((tag, index) => {
                            const value = typeof tag === 'string' ? tag : tag.value;
                            return (
                                <div title={tag?.desc} key={index}>
                                    <Tag
                                        key={index}
                                        active={active}
                                        onClose={e => {
                                            e?.stopPropagation();
                                            removeTag(index);
                                        }}
                                    >
                                        <bdi>{value}</bdi>
                                    </Tag>
                                </div>
                            );
                        })}
                    </Flex>
                </Scrollbar>
            )
        );
    }
);
